'use client';
import { useEffect, useRef, useState } from 'react';
import { Iframe } from 'components/UI/Embeds/Iframe';
import { Title, type TitleLink } from 'components/UI/Title';
import styles from './default.module.scss';

export type WidgetIframeDefaultProps = {
  readonly id: string;
  readonly model: {
    readonly fields: {
      readonly headline?: string;
      readonly link?: TitleLink;
      readonly iframe: string;
      readonly width?: string;
      readonly height?: string;
      readonly widthMobile?: string;
      readonly heightMobile?: string;
      readonly targetUrl?: string;
      readonly openInNewTab?: boolean;
      readonly contentstreams?: object;
    };
  };
};

export const WidgetIframeDefault = ({ context }: { context: WidgetIframeDefaultProps }) => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    if (sectionRef.current) {
      if (sectionRef.current.offsetWidth > 900) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const fields = context.model.fields;

  const iframeWidth = isMobile && fields.widthMobile ? fields.widthMobile : fields.width;
  const iframeHeight = isMobile && fields.heightMobile ? fields.heightMobile : fields.height;

  return (
    <section ref={sectionRef}>
      {fields.headline && <Title link={fields?.link}>{fields.headline}</Title>}
      {fields.targetUrl ? (
        <a className={styles.link} href={fields.targetUrl} target={fields.openInNewTab ? '_blank' : undefined}>
          <Iframe
            className={styles.iFrameWithLink}
            src={fields.iframe}
            width={iframeWidth}
            height={iframeHeight}
            id={context.id}
          />
        </a>
      ) : (
        <Iframe src={fields.iframe} width={iframeWidth} height={iframeHeight} id={context.id} />
      )}
    </section>
  );
};
